export default {"src":"/_next/static/media/retry.dacd55be.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};